/**
 * Application Configuration
 * Loads environment variables injected by webpack.dotenv.js during build
 */

export default {
  appMode: process.env.APP_MODE || "development",
  apiEndpoint: process.env.API_ENDPOINT || "https://api.kevi.io",
  mixpanelAppId: process.env.MIXPANEL_APP_ID || "",
  gtmId: process.env.GTM_ID || "",
  
  // Computed properties
  isDevelopment() {
    return this.appMode === "development";
  },
  
  isProduction() {
    return this.appMode === "production";
  }
};

